<template>
  <div id="all" class="animated fadeIn">
    <b-card>
      <b-card-body>
        <div v-if="!loading">
          <template v-for="(details, type) in data.this_week">
            <b-row :key="uniqueId(type+'A')" v-if="data">
              <table class="rekap-ro table-bordered table-responsive">
                <thead>
                  <tr>
                    <th :colspan="19">{{type}}</th>
                  </tr>
                  <tr>
                    <th rowspan="3" class="width-250">Customer</th>
                    <th colspan="3" class="width-250">{{last_week_label}}</th>
                    <template v-for="(v, index) in details.label">
                      <th colspan="3" :key="uniqueId(index+'A')" class="width-250">{{v}}</th>
                    </template>
                  </tr>

                  <tr>
                    <template v-for="(v, index) in warehouse[last_week_label]">
                      <th :key="uniqueId(index+'A2')" class="width-250">{{v}}</th>
                    </template>
                    <template v-for="v in details.label">
                      <template v-for="(v2, index2) in warehouse[v]">
                        <th :key="uniqueId(index2+'B')" class="width-100">{{v2}}</th>
                      </template>
                    </template>
                  </tr>
                </thead>

                <tbody>
                  <template v-for="(v, index) in customer">
                    <tr :key="uniqueId(index+'B')">
                      <td>{{index}}</td>
                      <template v-for="(vw2, index2) in warehouse">
                        <template v-for="(v2, index3) in vw2">
                          <td v-if="index2 === last_week_label" :key="uniqueId(index3+'D')">{{formatPrice(data.last_week[type].data[index2][v2][index])}}</td>
                          <td v-else :key="uniqueId(index3+'C')" v-bind:class="details['color-table'][index2]">{{formatPrice(details.data[index2][v2][index])}}</td>
                        </template>
                      </template>
                    </tr>
                  </template>
                </tbody>
              </table>
            </b-row>
          </template>

          <template v-for="(details, type) in product_history">
            <b-row :key="uniqueId(type+'A')" v-if="data">
              <table class="rekap-ro table-bordered table-responsive">
                <thead>
                  <tr>
                    <th rowspan="3" class="width-250">Customer</th>
                    <template v-for="(v, index) in details.label">
                      <th colspan="3" :key="uniqueId(index+'A')" class="width-250">{{v}}</th>
                    </template>
                  </tr>
                  <tr>
                    <template v-for="v in details.label">
                      <template v-for="(v2, index2) in warehouse[v]">
                        <th :key="uniqueId(index2+'B')" class="width-100">{{v2}}</th>
                      </template>
                    </template>
                  </tr>
                </thead>

                <tbody>
                  <!-- <template v-for="(v, index) in details.data"> -->
                    <tr>
                      <td>{{type}}</td>
                      <template v-for="(val_label) in details.label">
                        <template v-for="(val_wh, val_indx) in warehouse[val_label]">
                          <td :key="uniqueId(val_indx+'C')" v-bind:class="details['color-table'][val_label]">{{formatPrice(details.data[val_label][val_wh])}}</td>
                        </template>
                      </template>
                    </tr>
                  <!-- </template> -->
                </tbody>
              </table>
            </b-row>
          </template>
         
        </div>
        <div v-else>
          <loading></loading>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import * as moment from "moment";
import _ from "lodash";

export default {
  name: "dashboard-recap-warehoouse",
  components: {
    loading
  },
  props: {},
  data: function() {
    return {
      data: [],
      customer: [],
      description: [],
      warehouse: [],
      product_history: [],
      last_week_label: null,
      loading: true
    };
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    init: function() {
      this.loading = true;
      let employee_id = localStorage.getItem("employee_id");
      this.axios
        .get("web/recap_warehouse/calculation/")
        .then(response => {
          this.data = response.data;
          //this.detail = response.data.detail.data;
          //this.description = response.data.detail.description;
          this.warehouse = response.data.warehouse;
          this.customer = response.data.customer;
          this.last_week_label = response.data.last_week_label;
          this.product_history = response.data.product_history;
          ///data.last_week[type].label
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });

      // this.axios
      // .get("web/recap_ro/calculation-detail/")
      // .then(response => {
      //   this.detail = response.data.data;
      // })
      // .catch(error => {})
      // .finally(() => {
      //   this.loading = false;
      // });
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>